// Mock data for PREBATI website

export const companyInfo = {
  name: "PREBATI",
  tagline: "PREBATI ouvre la voie du béton précontraint industriel en Mauritanie.",
  phone: "43111616",
  email: "contact@prebati-mr.com",
  website: "www.prebati-mr.com",
  location: "Nouakchott – Mauritanie",
  logo: "https://customer-assets.emergentagent.com/job_c23391fd-ccad-4ca7-93e2-e648eb8747ed/artifacts/hcd9fosi_Logo%20complet.png"
};

export const heroContent = {
  title: "Planchers en béton précontraint & produits béton industriels, fabriqués en Mauritanie",
  subtitle: "PREBATI est la première usine mauritanienne spécialisée dans la fabrication de planchers en béton précontraint, sous licence OTEP France, destinés aux projets résidentiels, collectifs, administratifs et industriels.",
  intro: "Grâce à un procédé industriel éprouvé et certifié, PREBATI propose des solutions plus rapides, plus sûres et plus économiques que les méthodes traditionnelles, tout en garantissant un haut niveau de qualité et de conformité technique.",
  keyPoints: [
    "Procédé industriel sous licence OTEP France",
    "Fabrication locale – normes françaises et européennes",
    "Planchers jusqu'à 9–10 m de portée",
    "Solutions adaptées aux chantiers mauritaniens"
  ],
  backgroundImage: "https://customer-assets.emergentagent.com/job_c23391fd-ccad-4ca7-93e2-e648eb8747ed/artifacts/lkx7oxoy_DJI_0358.JPG"
};

export const aboutContent = {
  title: "PREBATI, une industrie au service de la construction moderne",
  paragraphs: [
    "PREBATI est une entreprise industrielle mauritanienne spécialisée dans les produits en béton, avec une expertise forte dans les planchers en béton précontraint.",
    "Fruit d'un partenariat entre ECOBATI et OTEP, PREBATI opère sous licence OTEP France, une technologie éprouvée et utilisée à l'international depuis plusieurs décennies."
  ],
  objectives: [
    "Moderniser le secteur de la construction en Mauritanie",
    "Offrir des solutions fiables, compétitives et produites localement",
    "Accompagner les projets de construction avec un support technique complet"
  ],
  positioning: [
    { title: "Fabricant industriel", description: "Pas un revendeur – production locale maîtrisée" },
    { title: "Bureau d'études intégré", description: "Accompagnement technique de vos projets" },
    { title: "Production en usine contrôlée", description: "Qualité constante et tracée" },
    { title: "Support technique", description: "Assistance pour vos projets de construction" }
  ],
  image: "https://customer-assets.emergentagent.com/job_c23391fd-ccad-4ca7-93e2-e648eb8747ed/artifacts/s393vp4d_Usine%20Haute%20Qualite%CC%81.png"
};

export const prestressedConcreteContent = {
  title: "Le béton précontraint",
  subtitle: "Comprendre la technologie qui révolutionne la construction",
  sections: [
    {
      title: "Qu'est-ce que le béton précontraint ?",
      content: "Le béton précontraint est une technique de construction avancée qui consiste à mettre le béton sous compression avant qu'il ne supporte des charges. Cette précompression est obtenue en tendant des câbles d'acier à haute résistance avant le coulage du béton. Une fois le béton durci, la tension est relâchée, transmettant une compression permanente au béton."
    },
    {
      title: "Pourquoi la précontrainte améliore les performances ?",
      content: "Le béton résiste très bien à la compression mais moins à la traction. En précontraignant le béton, on élimine ou réduit considérablement les contraintes de traction, ce qui permet d'obtenir des éléments plus résistants, capables de franchir des portées plus importantes avec moins de matière."
    },
    {
      title: "Le procédé PREBATI",
      steps: [
        "Mise en tension des câbles d'acier à haute résistance",
        "Coulage du béton haute performance autour des câbles tendus",
        "Cure et durcissement contrôlé du béton",
        "Relâchement de la précontrainte – transfert de la compression au béton",
        "Contrôle qualité et stockage"
      ]
    }
  ],
  benefits: [
    { title: "Résistance supérieure", description: "Capacité portante accrue par rapport au béton armé classique" },
    { title: "Portées plus longues", description: "Possibilité de franchir jusqu'à 9-10 mètres sans appui intermédiaire" },
    { title: "Moins de fissuration", description: "La précompression réduit drastiquement les risques de fissures" },
    { title: "Durabilité accrue", description: "Meilleure résistance dans le temps, notamment en climat sahélien" }
  ],
  image: "https://images.unsplash.com/photo-1715656423856-622b7f911c78"
};

export const products = [
  {
    id: "planchers",
    title: "Planchers en béton précontraint",
    description: "Système poutrelles + hourdis en béton pour des planchers performants et économiques.",
    details: [
      "Hourdis disponibles en 12, 16, 20 et 25 cm de hauteur",
      "Portées optimisées grâce aux calculs de notre bureau d'études",
      "Adapté aux constructions résidentielles, collectives et industrielles"
    ],
    useCases: ["Maisons individuelles", "Immeubles collectifs", "Bâtiments administratifs", "Locaux industriels"],
    advantages: ["Rapidité de pose", "Économie de main d'œuvre", "Portées jusqu'à 10m", "Qualité industrielle constante"],
    image: "https://customer-assets.emergentagent.com/job_c23391fd-ccad-4ca7-93e2-e648eb8747ed/artifacts/rzqz54vr_DJI_20260112145622_0029_D.JPG"
  },
  {
    id: "parpaings",
    title: "Produits pressés",
    description: "Large gamme de blocs béton pour tous vos projets de maçonnerie.",
    details: [
      "Blocs creux (10, 15, 20 cm)",
      "Blocs à bancher (20, 30, 40 cm)",
      "Blocs poteaux et chaînages"
    ],
    useCases: ["Murs porteurs", "Cloisons", "Clôtures", "Fondations"],
    advantages: ["Production locale", "Normes respectées", "Large choix"],
    image: "https://customer-assets.emergentagent.com/job_c23391fd-ccad-4ca7-93e2-e648eb8747ed/artifacts/uqxn6eua__50A7387.JPG"
  },
  {
    id: "poutres",
    title: "Poutres de stock",
    description: "Poutres en béton standard pour vos besoins courants de construction.",
    details: [
      "Dimensions standard 20×20 cm",
      "Diverses longueurs disponibles",
      "Qualité contrôlée en usine"
    ],
    useCases: ["Structures porteuses", "Linteaux", "Chainages"],
    advantages: ["Disponibilité immédiate", "Qualité constante", "Prix compétitif"],
    image: "https://images.unsplash.com/photo-1732636844217-5acf045486fc"
  },
  {
    id: "paves",
    title: "Pavés béton",
    description: "Pavés autobloquants pour vos aménagements extérieurs.",
    details: [
      "Différentes formes et épaisseurs",
      "Résistance au trafic",
      "Finitions variées"
    ],
    useCases: ["Voiries", "Cours", "Parkings", "Trottoirs"],
    advantages: ["Durabilité", "Facilité de pose", "Entretien minimal", "Esthétique"],
    image: "https://images.pexels.com/photos/236709/pexels-photo-236709.jpeg"
  }
];

export const engineeringOffice = {
  title: "Un bureau d'études intégré à votre service",
  subtitle: "PREBATI accompagne vos projets dès la phase de conception",
  description: "Notre bureau d'études vous accompagne pour optimiser vos planchers et garantir la conformité technique de vos ouvrages. De la conception à la réalisation, bénéficiez d'un support technique expert.",
  services: [
    {
      title: "Dimensionnement des planchers",
      description: "Calcul précis des sections de poutrelles selon les charges et portées de votre projet."
    },
    {
      title: "Calculs de charges et portées",
      description: "Analyse des contraintes et optimisation des solutions structurelles."
    },
    {
      title: "Optimisation des sections",
      description: "Réduction des coûts tout en maintenant les performances requises."
    },
    {
      title: "Assistance technique",
      description: "Accompagnement des ingénieurs et bureaux de contrôle tout au long du projet."
    }
  ],
  image: "https://customer-assets.emergentagent.com/job_c23391fd-ccad-4ca7-93e2-e648eb8747ed/artifacts/l0pq16qh_ChatGPT%20Image%20Jan%2014%2C%202026%2C%2001_52_09%20AM.png"
};

export const comparisonData = {
  title: "Construction traditionnelle ou solution industrielle ?",
  subtitle: "Comparez et choisissez la meilleure option pour votre projet",
  criteria: [
    {
      aspect: "Coffrage",
      traditional: "Coffrage bois sur site, consommateur de temps et de main d'œuvre",
      prebati: "Pas de coffrage nécessaire – pose directe des poutrelles et hourdis"
    },
    {
      aspect: "Main d'œuvre",
      traditional: "Équipe nombreuse requise, compétences variées nécessaires",
      prebati: "Équipe réduite, formation rapide à la mise en œuvre"
    },
    {
      aspect: "Délais",
      traditional: "Longs délais de coffrage, ferraillage, coulage et décoffrage",
      prebati: "Mise en œuvre rapide, gain de temps significatif sur chantier"
    },
    {
      aspect: "Qualité",
      traditional: "Variable selon les conditions de chantier et la main d'œuvre",
      prebati: "Constante – production industrielle contrôlée en usine"
    },
    {
      aspect: "Risque d'erreur",
      traditional: "Élevé – dépend de l'exécution sur chantier",
      prebati: "Minimal – éléments préfabriqués aux dimensions exactes"
    },
    {
      aspect: "Portées possibles",
      traditional: "Limitées par la complexité du ferraillage",
      prebati: "Jusqu'à 9-10 mètres grâce à la précontrainte"
    }
  ]
};

export const qualityContent = {
  title: "Qualité & Conformité",
  subtitle: "Un engagement qualité à chaque étape de la production",
  description: "PREBATI s'engage à livrer des produits conformes aux normes les plus exigeantes. Notre processus de contrôle qualité garantit la traçabilité et la fiabilité de chaque élément produit.",
  steps: [
    {
      title: "Sélection des matières premières",
      description: "Agrégats, ciment et aciers sélectionnés selon des critères stricts de qualité."
    },
    {
      title: "Contrôle du béton",
      description: "Tests réguliers de résistance et de consistance du béton frais."
    },
    {
      title: "Supervision de la fabrication",
      description: "Suivi rigoureux de chaque étape du processus de production."
    },
    {
      title: "Vérification des produits finis",
      description: "Contrôle dimensionnel et visuel de chaque élément avant stockage."
    }
  ],
  certifications: [
    "Conformité aux normes françaises",
    "Conformité aux normes européennes",
    "Traçabilité complète des lots",
    "Licence OTEP France"
  ],
  image: "https://customer-assets.emergentagent.com/job_c23391fd-ccad-4ca7-93e2-e648eb8747ed/artifacts/azffbzbe__50A7317.JPG"
};

export const articles = [
  {
    id: "quest-ce-que-le-beton-precontraint",
    title: "Qu'est-ce que le béton précontraint ?",
    excerpt: "Découvrez les principes fondamentaux du béton précontraint et comment cette technologie révolutionne la construction moderne.",
    content: "Le béton précontraint est une technique de construction qui consiste à mettre le béton sous compression permanente avant sa mise en service. Cette précompression est obtenue en tendant des câbles ou des torons d'acier à haute résistance...",
    date: "2025-01-15",
    readTime: "5 min",
    category: "Technologie"
  },
  {
    id: "beton-precontraint-vs-beton-arme",
    title: "Béton précontraint vs béton armé",
    excerpt: "Comparaison détaillée entre ces deux technologies : avantages, inconvénients et cas d'usage recommandés.",
    content: "Le béton armé et le béton précontraint sont deux techniques complémentaires mais distinctes. Le béton armé utilise des armatures passives tandis que le précontraint met en œuvre des armatures actives...",
    date: "2025-02-10",
    readTime: "7 min",
    category: "Comparatif"
  },
  {
    id: "pourquoi-choisir-plancher-industriel",
    title: "Pourquoi choisir un plancher industriel ?",
    excerpt: "Les avantages économiques et techniques des planchers préfabriqués par rapport aux solutions coulées sur place.",
    content: "Les planchers industriels préfabriqués offrent de nombreux avantages par rapport aux méthodes traditionnelles de construction. La production en usine garantit une qualité constante...",
    date: "2025-03-05",
    readTime: "6 min",
    category: "Guide pratique"
  },
  {
    id: "avantages-precontraint-climat-sahelien",
    title: "Avantages du précontraint en climat sahélien",
    excerpt: "Comment le béton précontraint répond aux défis spécifiques de la construction en Mauritanie et dans la région sahélienne.",
    content: "Le climat sahélien impose des contraintes particulières aux matériaux de construction : chaleur intense, amplitudes thermiques importantes, vents de sable... Le béton précontraint présente des avantages spécifiques pour ces conditions...",
    date: "2025-04-20",
    readTime: "8 min",
    category: "Local"
  }
];

export const navigationLinks = [
  { name: "Accueil", path: "/" },
  { name: "Qui sommes-nous", path: "/about" },
  { name: "Béton précontraint", path: "/prestressed-concrete" },
  { name: "Produits", path: "/products" },
  { name: "Bureau d'études", path: "/engineering" },
  { name: "Comparatif", path: "/comparison" },
  { name: "Qualité", path: "/quality" },
  { name: "Articles", path: "/articles" }
];
